
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[level1]",
      function () {
        return require("private-next-pages/[level1]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[level1]"])
      });
    }
  